export default "__VITE_ASSET__DzjwVNPz__"